module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.ready),
      expression: "!ready"
    }],
    staticClass: "product-lines-loading-wrap",
    staticStyle: {
      "width": "100%",
      "min-height": "220px",
      "position": "relative"
    },
    attrs: {
      "element-loading-text": _vm.$t('static.loadingProductLines')
    }
  }, [_c('v-form-table', {
    ref: "formTable",
    staticClass: "ediorderproduct-table",
    attrs: {
      "form": _vm.form,
      "list": _vm.list,
      "translation": "table.orderProducts",
      "disableForm": !_vm.canBeConfirmed,
      "update": _vm.confirm,
      "stack": {
        price: 'productDepositName'
      },
      "clickHandler": _vm.tableClickHandler,
      "tagHandler": _vm.tableTagHandler,
      "is-edi": true,
      "hiddenFields": _vm.hiddenFields
    }
  }), _vm._v(" "), _c('v-totals-table', {
    attrs: {
      "list": _vm.totalsTableList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de2df1ea","hasScoped":false}!./src/app/components/ediOrderItemsTable/ediOrderItemsTable.html
// module id = 3130
// module chunks = 1